import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import * as cons from '../../constants';
import detectOutsideClick from '../../modules/hooks/detectOutsideClick';
function Selections({ selectedId, handleSelect, selection, idAttr, textAttr, width, fontSize, notEditable = false, }) {
    const dropDownRef = useRef(null);
    const [selectionModalVisible, setSelectionModalVisible] = useState(false);
    const selected = selection
        ? selection.find((s) => s[idAttr] === selectedId)
        : null;
    const handleClickForm = () => {
        const visible = !selectionModalVisible;
        setSelectionModalVisible(visible);
    };
    const closeDropDown = () => {
        setSelectionModalVisible(false);
    };
    detectOutsideClick(dropDownRef, closeDropDown, selectionModalVisible);
    return (React.createElement(SelectionDefaultWrapper, { width: width, fontSize: fontSize || 16, ref: dropDownRef },
        React.createElement(SelectedText, { onClick: handleClickForm, notEditable: notEditable, fontSize: fontSize || 16 },
            selected ? selected[textAttr] : '-',
            React.createElement(CaretDown, { src: "/icons/down-arrow-black.png" })),
        React.createElement(DropdownModal, { visible: selectionModalVisible },
            React.createElement(SelectionModal, null, selection &&
                selection.length > 0 &&
                selection.map((s) => (React.createElement(SelectionItem, { key: s[idAttr], onClick: () => {
                        handleSelect(s[idAttr]);
                        setSelectionModalVisible(false);
                    } }, s[textAttr])))))));
}
const SelectionDefaultWrapper = styled.div `
  width: 100%;
  width: ${(props) => props.width}px;
  display: block;
  position: relative;
  font-size: ${(props) => props.fontSize}px;
`;
const SelectedText = styled.div `
  cursor: pointer;
  position: relative;
  width: 100%;
  color: ${cons.COLOR_GRAY_6};
  font-weight: 500;
  user-select: none;
  border-radius: 4px;

  /* border: 2px solid #dfdfdf; */
  /* box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2); */

  background-color: ${cons.COLOR_GRAY_1};
  padding: 12px 12px;
  box-sizing: border-box;
  font-size: ${(props) => props.fontSize}px;

  ${(props) => props.notEditable &&
    `
    background-color: white;  
    border: none;
    margin-top: -10px;
    padding-left: 0;
    pointer-events: none;
    color: ${cons.COLOR_GRAY_6};
    font-weight: 500;
    word-wrap: none;
    word-break: break-all;
    line-height: 1.5em;
    & img {
      display: none;
    }
  `}
`;
const CaretDown = styled.img `
  width: 12px;
  position: absolute;
  top: 14px;
  right: 12px;
  opacity: 0.5;
`;
const SelectionModal = styled.div `
  padding: 8px 0px;
`;
const SelectionItem = styled.div `
  padding: 12px 12px;
  box-sizing: border-box;
  color: ${cons.COLOR_GRAY_6};
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${cons.COLOR_GRAY_2};
    color: ${cons.COLOR_GRAY_8};
  }
`;
const DropdownModal = styled.div `
  display: none;
  position: absolute;
  background-color: white;
  width: 100%;
  /* box-sizing: border-box; */
  border-radius: 4px;
  /* margin-top: 4px; */
  z-index: 1;
  box-shadow: ${cons.SHADOW_2};
  margin-top: 4px;
  ${(props) => props.visible &&
    `
  display: block;
  `};
`;
export default Selections;
